import { render } from "./ServiceAiBulan.vue?vue&type=template&id=0c432abc"
import script from "./ServiceAiBulan.vue?vue&type=script&lang=js"
export * from "./ServiceAiBulan.vue?vue&type=script&lang=js"

import "./ServiceAiBulan.vue?vue&type=style&index=0&id=0c432abc&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__